import { render, staticRenderFns } from "./file_view.vue?vue&type=template&id=76d67d50&scoped=true"
import script from "./file_view.vue?vue&type=script&lang=js"
export * from "./file_view.vue?vue&type=script&lang=js"
import style0 from "./file_view.vue?vue&type=style&index=0&id=76d67d50&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d67d50",
  null
  
)

export default component.exports